import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fechaNegocio, formatearCOP, formatearFecha } from '@tanteo/compartido';
import { listarVentas, type VentaResumen } from '../lib/api';
import { useApp } from '../lib/contexto';
import { BarraDePagina, Campo, EncabezadoTabla, Esqueleto, EstadoVacio, FilaTabla, Insignia, TablaAncha, Tarjeta } from '../ui/base';

export function Comprobantes() {
  const { negocio } = useApp();
  const esCajero = negocio?.rol === 'cajero';
  const [fecha, setFecha] = useState(fechaNegocio());
  const [ventas, setVentas] = useState<VentaResumen[] | null>(null);

  useEffect(() => {
    if (!negocio) return;
    setVentas(null);
    listarVentas(negocio.negocioId, esCajero ? fechaNegocio() : fecha)
      .then(setVentas)
      .catch(() => setVentas([]));
  }, [negocio, fecha, esCajero]);

  return (
    <div className="space-y-4">
      <BarraDePagina titulo="Comprobantes">
        {!esCajero && (
          <div className="w-44">
            <Campo etiqueta="Fecha" type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
          </div>
        )}
      </BarraDePagina>
      <Tarjeta>
        {ventas === null ? (
          <Esqueleto lineas={6} />
        ) : ventas.length === 0 ? (
          <EstadoVacio titulo="Sin comprobantes en esta fecha" detalle="Las ventas del mostrador aparecen aquí." />
        ) : (
          <TablaAncha>
              <EncabezadoTabla>
                  <th className="py-2 pr-2">Consecutivo</th>
                  <th className="py-2 pr-2">Fecha</th>
                  <th className="py-2 pr-2">Hora</th>
                  <th className="py-2 pr-2">Pago</th>
                  <th className="py-2 pr-2 text-right">Total</th>
                  <th className="py-2 pr-2">Estado</th>
              </EncabezadoTabla>
              <tbody>
                {ventas.map((v) => (
                  <FilaTabla key={v.id} className={v.estado === 'anulada' ? 'opacity-50' : ''}>
                    <td className="py-2 pr-2">
                      <Link to={`/comprobantes/${v.id}`} className="text-primary-deep font-bold underline">
                        {v.consecutivo}
                      </Link>
                    </td>
                    <td className="py-2 pr-2">{formatearFecha(v.fecha)}</td>
                    <td className="num py-2 pr-2">{v.hora}</td>
                    <td className="py-2 pr-2">{v.pagos.length > 1 ? v.pagos.map((g) => g.cuenta).join(' + ') : v.cuenta}</td>
                    <td className={`num py-2 pr-2 text-right font-bold ${v.estado === 'anulada' ? 'line-through' : ''}`}>
                      {formatearCOP(v.total)}
                    </td>
                    <td className="py-2 pr-2">
                      {v.estado === 'anulada' ? <Insignia tono="peligro">Anulado</Insignia> : <Insignia tono="exito">Emitido</Insignia>}
                    </td>
                  </FilaTabla>
                ))}
              </tbody>
            </TablaAncha>
        )}
      </Tarjeta>
    </div>
  );
}
